import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fullName'
})
export class FullNamePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const fullName = value.split(' ')
    if (fullName.length === 3) {
      return `${fullName[0]} ${fullName[1][0].toUpperCase()}. ${fullName[2][0].toUpperCase()}.`
    } else {
      return value
    }
  }
}
